export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'Member Privilege',
      url: '/member-privilege',
      icon: 'icon-badge',
      module: 'JeetPrivilege',
      children: [
        {
          name: 'Member Level',
          url: '/member-privilege/member-level',
          icon: 'icon-user',
          module: 'JeetPrivilege.MemberLevel'
        },
        {
          name: 'Cashback',
          url: '/member-privilege/cashback',
          icon: 'fa fa-inr',
          module: 'JeetPrivilege.Cashback',
          children: [
            {
              name: 'Report',
              url: '/member-privilege/cashback/report',
              icon: 'fa fa-bar-chart',
              module: 'JeetPrivilege.Cashback.Report'
            },
            {
              name: 'Sports Report',
              url: '/member-privilege/cashback/sportsReport',
              icon: 'fa fa-bar-chart',
              module: 'JeetPrivilege.SportsCashback'
            },
            {
              name: 'Early Cashback',
              url: '/member-privilege/cashback/earlyCashback',
              icon: 'fa fa-inr',
              module: 'JeetPrivilege.Cashback.EarlyCashback'
            },
            {
              name: 'Cashback Job Log',
              url: '/member-privilege/cashback/cashbackjoblog',
              icon: 'fa fa-android',
              module: 'JeetPrivilege.Cashback.BotLog'
            },
            {
              name: 'Special Member Rate',
              url: '/member-privilege/cashback/special-member',
              icon: 'fa fa-users',
              module: 'JeetPrivilege.Cashback.SpecialMember'
            }
          ]
        },
        {
          name: 'Monthly Tier Bonus',
          url: '/member-privilege/vip-program',
          icon: 'fa fa-money',
          module: 'JeetPrivilege.VipProgram'
        }
      ]
    },
    {
      name: 'Payment',
      url: '/payment',
      icon: 'icon-calculator',
      module: 'Payment',
      children: [
        {
          name: 'VIP Level',
          url: '/payment/viplevel',
          icon: 'fa fa-star',
          module: 'Payment.Level',
          children: [
            {
              name: 'Level Settings',
              url: '/payment/viplevel/viplevel-settings',
              icon: 'fa fa-gears',
              module: 'Payment.Level.Settings'
            },
            {
              name: 'Member',
              url: '/payment/viplevel/viplevel-member',
              icon: 'fa fa-users',
              module: 'Payment.Level.Member'
            },
            {
              name: 'Bank Maintenance',
              url: '/payment/viplevel/viplevel-bank',
              module: 'Payment.Level.BankMaintenance',
              icon: 'fa fa-bank'
            },
            {
              name: 'Account',
              url: '/payment/viplevel/viplevel-account',
              icon: 'fa fa-university',
              module: 'Payment.Level.Account'
            },
            {
              name: 'Payment Options',
              url: '/payment/viplevel/viplevel-payment',
              icon: 'fa fa-gears',
              module: 'Payment.Level.Options'
            }
          ]
        },
        {
          name: 'VIP Level Withdraw',
          url: '/payment/withdraw/viplevel',
          module: 'Payment.WithdrawViplevel',
          icon: 'fa fa-star',
          children: [
            {
              name: 'Level Settings',
              url: '/payment/withdraw/viplevel/viplevel-settings',
              module: 'Payment.WithdrawViplevel.LevelSettings',
              icon: 'fa fa-gears'
            },
            {
              name: 'Member',
              url: '/payment/withdraw/viplevel/viplevel-member',
              module: 'Payment.WithdrawViplevel.Member',
              icon: 'fa fa-users'
            },
            {
              name: 'Withdraw Method',
              url: '/payment/withdraw/viplevel/viplevel-payment',
              module: 'Payment.WithdrawViplevel.Method',
              icon: 'fa fa-bank'
            }
          ]
        },
        {
          name: 'Bank',
          url: '/payment/bank',
          icon: 'fa fa-bank',
          module: 'Payment.Bank',
          children: [
            {
              name: 'Receipt Account',
              url: '/payment/bank/receiptAccount',
              module: 'Payment.Bank.ReceiptAccount',
              icon: 'fa fa-credit-card'
            }
          ]
        },
        {
          name: 'Bank Maintenance',
          url: '/payment/manualDeposit',
          icon: 'fa fa-bank',
          module: 'Payment.ManualDeposit'
        },
        {
          name: 'Whitelist',
          url: '/payment/whitelist',
          icon: 'fa fa-check',
          module: 'Payment.Whitelist',
          children: [
            {
              name: 'Withdraw',
              url: '/payment/whitelist/withdraw-whitelist',
              module: 'Payment.Whitelist.Withdraw',
              icon: 'fa fa-money'
            }
          ]
        },
        {
          name: 'Records',
          url: '/payment/records',
          module: 'Payment.Records',
          icon: 'fa fa-list',
          children: [
            {
              name: 'Withdraw',
              url: '/payment/records/withdraw',
              module: 'Payment.Records.Withdraw',
              icon: 'fa fa-bank'
            },
            {
              name: 'Member Bank IFSC',
              url: '/payment/records/memberBankIFSC',
              module: 'Payment.Records.MemberBankIFSC',
              icon: 'fa fa-bank'
            },
            {
              name: 'ICICI Payout',
              url: '/payment/records/ICICIPayout',
              module: 'Payment.Records.ICICI.Payout',
              icon: 'fa fa-bank'
            }
          ]
        },
        {
          name: 'LP Redeem Request',
          url: '/payment/lp-redeem-request',
          module: 'Payment.LoyaltyRedeem.Request',
          icon: 'fa fa-product-hunt'
        }
      ]
    },
    {
      name: 'Promotion',
      url: '/promotion',
      icon: 'fa fa-gift',
      module: 'Promotion',
      children: [
        {
          name: 'Referral Bonus',
          url: '/promotion/referral',
          module: 'Promotion.Referral',
          icon: 'fa fa-users'
        },
        {
          name: 'Reward Bonus',
          url: '/promotion/loyaltyreward',
          module: 'Promotion.RewardBonus',
          icon: 'fa fa-money'
        },
        {
          name: 'Promo Code',
          url: '/promotion/promoCode',
          module: 'Promotion.PromoCode',
          icon: 'icon-tag'
        },
        {
          name: 'Referral Commission',
          url: '/promotion/referral-commission',
          module: 'Promotion.ReferralCommission',
          icon: 'fa fa-money'
        }
      ]
    },
    {
      name: 'Lucky Wheel',
      url: '/base',
      icon: 'icon-game-controller',
      module: 'LuckyDraw',
      children: [
        {
          name: 'Domain',
          url: '/lucky-wheel/domain',
          module: 'LuckyDraw.Domain',
          icon: 'icon-globe'
        },
        {
          name: 'Ticket',
          url: '/lucky-wheel/ticket',
          module: 'LuckyDraw.Ticket',
          icon: 'icon-tag'
        },
        {
          name: 'Draw',
          url: '/lucky-wheel/draw',
          module: 'LuckyDraw.Draw',
          icon: 'fa fa-archive'
        },
        {
          name: 'Draw List',
          url: '/lucky-wheel/draw-list',
          module: 'LuckyDraw.DrawList',
          icon: 'icon-list'
        },
        {
          name: 'Gift',
          url: '/lucky-wheel/gift',
          module: 'LuckyDraw.Gift',
          icon: 'icon-present'
        },
        {
          name: 'Gift List',
          url: '/lucky-wheel/gift-list',
          module: 'LuckyDraw.GiftList',
          icon: 'icon-list'
        },
        {
          name: 'Rule',
          url: '/lucky-wheel/rule',
          module: 'LuckyDraw.Rule',
          icon: 'icon-note'
        },
        {
          name: 'Rule List',
          url: '/lucky-wheel/rule-list',
          module: 'LuckyDraw.RuleList',
          icon: 'icon-list'
        }
      ]
    },
    {
      name: 'Scratch Card',
      url: '/base',
      module: 'ScratchCard',
      icon: 'icon-game-controller',
      children: [
        {
          name: 'Settings',
          url: '/scratch-card/settings',
          module: 'ScratchCard.Settings',
          icon: 'icon-settings'
        },
        {
          name: 'Rewards',
          url: '/scratch-card/rewards',
          module: 'ScratchCard.Rewards',
          icon: 'icon-present'
        },
        {
          name: 'Tickets',
          url: '/scratch-card/tickets',
          module: 'ScratchCard.Tickets',
          icon: 'icon-tag'
        }
      ]
    },
    {
      name: 'Lottery',
      url: '/base',
      module: 'Lottery',
      icon: 'icon-game-controller',
      children: [
        {
          name: 'Settings',
          url: '/lottery/settings',
          module: 'Lottery.Settings',
          icon: 'icon-settings'
        },
        {
          name: 'Draw',
          url: '/lottery/draw',
          module: 'Lottery.Draw',
          icon: 'icon-present'
        },
        {
          name: 'Ticket',
          url: '/lottery/tickets',
          module: 'Lottery.Tickets',
          icon: 'icon-tag'
        }
      ]
    },
    {
      name: 'AutoCashIn',
      url: '/base',
      icon: 'icon-game-controller',
      module: 'AutoCashIn'
    },
    {
      title: true,
      name: 'Content Management',
      class: '',
      module: 'CMS',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Tournament',
      url: '/tournament',
      icon: 'fa fa-trophy',
      module: 'CMS.Tournament',
      children: [
        {
          name: 'Main',
          url: '/tournament/main',
          icon: 'fa fa-trophy',
          module: 'CMS.Tournament.Main'
        },
        {
          name: 'Quick',
          url: '/tournament/quick',
          icon: 'fa fa-trophy',
          module: 'CMS.Tournament.Quick'
        }
      ]
    },
    {
      name: 'Poster Ad',
      url: '/poster-ad',
      icon: 'fa fa-image',
      module: 'CMS.Poster'
    },
    {
      name: 'Game Platforms',
      url: '/game-platforms',
      icon: 'fa fa-gamepad',
      module: 'CMS.GamePlatforms'
    },
    {
      name: 'Game Images',
      url: '/game-images',
      icon: 'fa fa-gamepad',
      module: 'CMS.GameImages'
    },
    {
      name: 'Game Thumbnails',
      url: '/game-thumbnails',
      icon: 'fa fa-image',
      module: 'CMS.GameThumbnails'
    },
    {
      title: true,
      name: 'Report & Logs',
      class: '',
      module: 'RL',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Report',
      url: '/report',
      icon: 'fa fa-bar-chart',
      module: 'RL.Report',
      children: [
        {
          name: 'PNL',
          url: '/report/payment/pnl',
          icon: 'icon-calculator',
          module: 'RL.Report.PNL'
        },
        {
          name: 'Daily Deposit',
          url: '/report/payment/dailyDeposit',
          icon: 'icon-calculator',
          module: ''
        },
        {
          name: 'Member Bank Detail',
          url: '/report/member/memberBank',
          icon: 'fa fa-user',
          module: 'RL.Report.MemberBank'
        },
        {
          name: 'Daily Report Detail',
          url: '/report/member/dailyReport',
          icon: 'fa fa-book',
          module: 'RL.Report.DailyReport'
        },
        {
          name: 'Daily Signup Detail',
          url: '/report/member/dailySignup',
          icon: 'fa fa-user',
          module: 'RL.Report.DailySignup'
        },
        {
          name: 'Inactive Member Detail',
          url: '/report/member/inactiveMember',
          icon: 'fa fa-user',
          module: 'RL.Report.InactiveMember'
        },
        {
          name: 'Promotion',
          url: '/report/promotion',
          icon: 'fa fa-gift',
          module: 'RL.Report.Promotion',
          children: [
            {
              name: 'Promotion Join',
              url: '/report/promotion/join',
              icon: 'fa fa-gift',
              module: 'RL.Report.Promotion.Join'
            },
            {
              name: 'Promo Code',
              url: '/report/promotion/promo-code',
              icon: 'fa fa-gift',
              module: 'RL.Report.Promotion.PromoCode'
            }
          ]
        },
        {
          name: 'Mini Games',
          url: '/report/mini-games',
          icon: 'icon-game-controller',
          module: 'RL.Report.MiniGames',
          children: [
            {
              name: 'LuckyWheel Report',
              url: '/report/mini-games/luckywheel',
              icon: 'icon-game-controller',
              module: 'RL.Report.MiniGames.LuckyWheel'
            },
            {
              name: 'Scratch Card Report',
              url: '/report/mini-games/scratchcard',
              icon: 'icon-game-controller',
              module: 'RL.Report.MiniGames.ScratchCard'
            },
            {
              name: 'Lottery Report',
              url: '/report/mini-games/lottery',
              icon: 'icon-game-controller',
              module: 'RL.Report.MiniGames.Lottery'
            }
          ]
        },
        {
          name: 'Risk',
          url: '/report/member/riskAnalysis',
          icon: 'fa fa-user',
          module: 'RL.Report.RiskAnalysis',
          children: [
            {
              name: 'Daily Signup',
              url: '/report/member/riskAnalysis/dailySignup',
              icon: 'fa fa-star',
              module: 'RL.Report.RiskAnalysis.DailySignup'
            },
            {
              name: 'Daily First Deposit',
              url: '/report/member/riskAnalysis/dailyFirstDeposit',
              icon: 'fa fa-star',
              module: 'RL.Report.RiskAnalysis.DailySignup'
            },
            {
              name: 'High Turnover Games',
              url: '/report/member/riskAnalysis/highTurnover',
              icon: 'fa fa-star',
              module: 'RL.Report.RiskAnalysis.HighTurnover'
            },
            {
              name: 'High Payout Games',
              url: '/report/member/riskAnalysis/highPayout',
              icon: 'fa fa-star',
              module: 'RL.Report.RiskAnalysis.HighPayout'
            },
            {
              name: 'High Abnormal Bet',
              url: '/report/member/riskAnalysis/abnormalBet',
              icon: 'fa fa-star',
              module: 'RL.Report.RiskAnalysis.AbnormalBet'
            },
            {
              name: 'Game Trend',
              url: '/report/member/riskAnalysis/gameTrend',
              icon: 'fa fa-star',
              module: 'RL.Report.RiskAnalysis.GameTrend'
            }
          ]
        }
      ]
    },
    {
      name: 'Logs',
      url: '/activity-log',
      icon: 'fa fa-paper-plane',
      module: 'RL.Logs',
      children: [
        {
          name: 'Payment',
          url: '/payment',
          icon: 'icon-calculator',
          module: 'RL.Logs.Payment',
          children: [
            {
              name: 'VIP Level',
              url: '/activity-log/payment/viplevel',
              icon: 'fa fa-star',
              module: 'RL.Logs.Payment.Viplevel',
              children: [
                {
                  name: 'Level Settings',
                  url: '/activity-log/payment/viplevel/settings',
                  icon: 'fa fa-paper-plane',
                  module: 'RL.Logs.Payment.Viplevel.LevelSettings'
                },
                {
                  name: 'Member',
                  url: '/activity-log/payment/viplevel/member',
                  icon: 'fa fa-paper-plane',
                  module: 'RL.Logs.Payment.Viplevel.LevelMember'
                },
                {
                  name: 'Account',
                  url: '/activity-log/payment/viplevel/account',
                  icon: 'fa fa-paper-plane',
                  module: 'RL.Logs.Payment.Viplevel.LevelAccount'
                },
                {
                  name: 'Payment Options',
                  url: '/activity-log/payment/viplevel/payment',
                  icon: 'fa fa-paper-plane',
                  module: 'RL.Logs.Payment.Viplevel.LevelOptions'
                }
              ]
            },
            {
              name: 'VIP Level Withdraw ',
              url: '/activity-log/payment/withdraw',
              icon: 'fa fa-star',
              module: 'RL.Logs.Payment.WithdrawViplevel',
              children: [
                {
                  name: 'Member',
                  url: '/activity-log/payment/withdraw/member',
                  icon: 'fa fa-paper-plane',
                  module: 'RL.Logs.Payment.WithdrawViplevel.Member'
                },
                {
                  name: 'Withdraw Method',
                  url: '/activity-log/payment/withdraw/method',
                  icon: 'fa fa-paper-plane',
                  module: 'RL.Logs.Payment.WithdrawViplevel.Method'
                }
              ]
            }
          ]
        }
      ]
    },
    {
      title: true,
      name: 'Settings',
      class: '',
      module: 'System',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'System Config',
      url: '/system-config',
      icon: 'fa fa-key',
      module: 'System.Config'
    },
    {
      name: 'Access Privilege',
      url: '/access-privilege',
      icon: 'fa fa-key',
      module: 'System.AccessLimit'
    },
    {
      name: 'CDN Image Manager',
      url: '/cdn-image-manager',
      icon: 'fa fa-wrench',
      module: 'System.CDNFileManager'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js